class ReservedWords {
}
/** Words that cannot be used in companyName or classroomName */
ReservedWords.reservedCompanyNames = [
    'onshape',
    'onshape inc',
    'onshape support',
    'cad',
    'onshape standard content',
    'ptc',
    'ptc inc',
    'parametric technology corporation',
];
/** Words that cannot be used as firstName/lastName or in both for example: Onshape or On Shape */
ReservedWords.reservedFirstLastNames = [
    'btadmin',
    'admin',
    'sysuser',
    'everyone',
    'onshape',
    'friends',
    'anonymous',
];
export default ReservedWords;
